import { CityData, OfficeData } from "@/types";

export const getEntityName = (entityType: string, city: CityData | null, ao: OfficeData | null) => {
    if (entityType === 'city' && city) {
      return city.name;
    } else if (entityType === 'ao' && ao) {
      return ao.name;
    }
    return "";
};